/**
 * VENDOR MODULES
 */
import React from 'react';
import { useTranslation } from "react-i18next";

import FinalOutcomes from 'features/markets/components/baseball/singles/FinalOutcomes';
import NumberOfPitches from 'features/markets/components/baseball/singles/NumberOfPitches';
import FinalAndPitches from 'features/markets/components/baseball/combinations/FinalAndPitches';
import FinalAndOverUnders from 'features/markets/components/baseball/combinations/FinalAndOverUnders';
import { cn } from 'lib/utils';
import { getSportColor, getSportLightColor } from 'shared/utils/sport-colors';
import { vsMarketTypeKey } from 'lib/virtualSportsI18n';

/**
 * Renders the bet area for baseball
 *
 * @class      BaseballArea (name)
 * @param      {<type>}   props   The properties
 * @return     {boolean}  { description_of_the_return_value }
 */
function BaseballArea(props) {
  const { t } = useTranslation();
  const {
    event = {},
  } = props;

  const { outcomes } = event;
  const sport_id = event?.sport_id || 40;
  const sportColor = getSportColor(sport_id);
  const sportLightColor = getSportLightColor(sport_id);

  const [selectedGroup, setSelectedGroup] = React.useState('finalOutcomes'); // finalOutcomes | numberOfPitches | finalAndPitches | finalAndOverUnders

  const tabBtnClass = (isSelected) => cn(
    "w-full px-3 py-2 md:py-2.5 text-center cursor-pointer transition-colors text-xs rounded-md border-[3px] font-semibold",
    isSelected
      ? "border-[var(--sport-color)] bg-card text-foreground"
      : "border-border bg-card text-foreground hover:border-[var(--sport-color)]"
  );

  return (
    <div
      className="baseball-area w-full"
      data-sport-id={sport_id}
      style={{ '--sport-color': sportColor, '--sport-light-color': sportLightColor }}
    >
      <div className="grid grid-cols-2 md:grid-cols-4 gap-1 border-b border-border p-2">
        <button
          type="button"
          onClick={() => setSelectedGroup('finalOutcomes')}
          className={tabBtnClass(selectedGroup === 'finalOutcomes')}
        >
          <span className="block px-1 whitespace-normal break-words leading-tight">
            {t(vsMarketTypeKey(4001))}
          </span>
        </button>
        <button
          type="button"
          onClick={() => setSelectedGroup('numberOfPitches')}
          className={tabBtnClass(selectedGroup === 'numberOfPitches')}
        >
          <span className="block px-1 whitespace-normal break-words leading-tight">
            {t(vsMarketTypeKey(4002))}
          </span>
        </button>
        <button
          type="button"
          onClick={() => setSelectedGroup('finalAndPitches')}
          className={tabBtnClass(selectedGroup === 'finalAndPitches')}
        >
          <span className="block px-1 whitespace-normal break-words leading-tight">{t(vsMarketTypeKey(4003))}</span>
        </button>
        <button
          type="button"
          onClick={() => setSelectedGroup('finalAndOverUnders')}
          className={tabBtnClass(selectedGroup === 'finalAndOverUnders')}
        >
          <span className="block px-1 whitespace-normal break-words leading-tight">{t(vsMarketTypeKey(4004))}</span>
        </button>
      </div>

      {/* Final Outcome */}
      {selectedGroup === 'finalOutcomes' && (
        <div className="w-full">
          <FinalOutcomes outcomes={outcomes} />
        </div>
      )}

      {/* Pitches Number */}
      {selectedGroup === 'numberOfPitches' && (
        <div className="w-full">
          <NumberOfPitches outcomes={outcomes} />
        </div>
      )}

      {/* Final & Pitches */}
      {selectedGroup === 'finalAndPitches' && (
        <div className="w-full">
          <FinalAndPitches outcomes={outcomes} />
        </div>
      )}

      {/* Final & Over/Unders */}
      {selectedGroup === 'finalAndOverUnders' && (
        <div className="w-full">
          <FinalAndOverUnders outcomes={outcomes} />
        </div>
      )}
    </div>
  );
}

export default BaseballArea;

